import classNames from "classnames";
import noop from "lodash/noop";
import { FunctionComponent } from "react";
import "./style.scss";

export interface Props {
  checked: boolean;
  disabled?: boolean;
  hasError?: boolean;
  onClick: () => void;
  type: "primary" | "secondary";
}

const Radio: FunctionComponent<Props> = ({
  checked,
  disabled = false,
  hasError = false,
  onClick,
  type,
}) => {
  return (
    <div
      className={classNames(`Radio Radio--type-${type}`, {
        "Radio--checked": checked,
        "Radio--disabled": disabled,
        "Radio--error": hasError,
      })}
      onClick={disabled ? noop : onClick}
      tabIndex={disabled || hasError ? undefined : 1}
    >
      <div className="Radio-circle">
        <div className="Radio-circle-bullet" />
      </div>
    </div>
  );
};

export default Radio;
